/* eslint-disable no-console */

const ENABLE_LOGS = false;

export default class Logger {
	public static log(...args: any): void {
		if (ENABLE_LOGS) {
			console.log(...args);
		}
	}
}
